import React, { useState } from "react";
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { useDemoData } from "@/hooks/useDemoData";
import { DollarSign, TrendingUp, ArrowDown } from "lucide-react";
import DetailsModal from "../modals/DetailsModal";

export default function Dashboard() {
  const { loads } = useDemoData();
  const [modalType, setModalType] = useState<
    "recent-bids" | "active-loads" | "completed-loads" | null
  >(null);

  const activeCount = loads.filter(
    (l) => l.carrierID && new Date(l.deliveryEnd) > new Date()
  ).length;
  const completedCount = loads.filter(
    (l) => l.carrierID && new Date(l.deliveryEnd) <= new Date()
  ).length;

  const handleCardClick = (
    type: "recent-bids" | "active-loads" | "completed-loads"
  ) => {
    setModalType(type);
  };

  const closeModal = () => {
    setModalType(null);
  };

  return (
    <>
      <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-6">
        <Card
          className="cursor-pointer hover:shadow-lg transition-shadow"
          onClick={() => handleCardClick("active-loads")}
        >
          <CardHeader className="flex justify-between">
            <h3 className="text-lg font-semibold">Active Loads</h3>
            <TrendingUp />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{activeCount}</div>
            <p className="text-xs text-gray-500">in transit</p>
          </CardContent>
        </Card>

        <Card
          className="cursor-pointer hover:shadow-lg transition-shadow"
          onClick={() => handleCardClick("completed-loads")}
        >
          <CardHeader className="flex justify-between">
            <h3 className="text-lg font-semibold">Completed Loads</h3>
            <ArrowDown />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{completedCount}</div>
            <p className="text-xs text-gray-500">completed</p>
          </CardContent>
        </Card>
      </div>

      {/* Render modal when modalType is set */}
      {modalType && <DetailsModal type={modalType} onClose={closeModal} />}
    </>
  );
}
